import React from 'react';

// Plain field; Type/Dictate choice is offered globally by DictateOrType on focus
const VoiceDictationInput = ({
  value = '',
  onChange,
  placeholder = 'Type or dictate...',
  rows = 1,
  className = '',
  label = '',
  disabled = false,
  ...props
}) => {
  const InputComponent = rows > 1 ? 'textarea' : 'input';
  return (
    <div className="relative">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <InputComponent
        type={rows === 1 ? 'text' : undefined}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows > 1 ? rows : undefined}
        disabled={disabled}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#f39c12] focus:border-transparent ${className}`}
        {...props}
      />
    </div>
  );
};

export default VoiceDictationInput;
